<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-general />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-map-pin" :label="!isSmallerScreen ? 'Address' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-address />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-clock" :label="!isSmallerScreen ? 'Opening Hours' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-opening-hours />
      </div>
    </vs-tab>
    <!--
    <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Account' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-account />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Notifications' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <venue-notifications />
      </div>
    </vs-tab>
    -->
  </vs-tabs>
</template>

<script>
import VenueGeneral from './VenueGeneral.vue'
import VenueAddress from './VenueAddress.vue'
import VenueOpeningHours from './VenueOpeningHours.vue'
//import VenueAccount from './VenueAccount.vue'
//import VenueNotifications from './VenueNotifications.vue'

export default {
  components: {
    VenueGeneral,
    VenueAddress,
    VenueOpeningHours,
    //VenueAccount,
    //VenueNotifications
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
